export const APPLICATION_LIST_PATH = "/vacancies/:vacancyId/applications";
